import { Nullable } from '@dai/common'

import { PlanType, SubscriptionTypeFragment } from '@/graphql'

const isPlanType = (
  plan: SubscriptionTypeFragment,
  type: PlanType,
): boolean => {
  return plan.name.toLowerCase().includes(type.toLowerCase())
}

const getPlanTypeString = (
  t: (key: string) => string,
  planType: Nullable<PlanType>,
): string => {
  switch (planType) {
    case PlanType.BASIC:
      return t('planType.basic')
    case PlanType.PREMIUM:
      return t('planType.premium')
    case PlanType.PREMIUM_FREE:
      return t('planType.premium')
    case PlanType.ENTERPRISE:
      return t('planType.enterprise')
    default:
      return t('planType.unknown')
  }
}

export const SubscriptionHelpers = {
  isPlanType,
  getPlanTypeString,
}
